<template>
    <div class="container text-center">
        <div class="row g-2" v-if="skills.length">
            <div class="col-6" v-for="(skill, index) in  skills ">
                <div class="d-flex" :class="{ 'justify-content-end': Math.abs(index % 2) == 0, 'justify-content-start': Math.abs(index % 2) == 1 }">
                    <span class="rate" :class="{ red: skill.skill_code == 'reading', yellow: skill.skill_code == 'speaking', green: skill.skill_code == 'listening', orange: skill.skill_code == 'writing', active: skill.value >= point }"
                        v-for=" point  in  10 "></span>
                    <span class="rate-label text-nowrap text-capitalize">{{ skillName(skill.skill_code) }}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h4>{{ $t('empty_data') }}</h4>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SkillRatting",
    props: ['skills'],

    methods: {
        skillName(code) {
            var result;
            switch (code) {
                case 'reading':
                    result = this.$i18n.t('read')
                    break;
                case 'speaking':
                    result = this.$i18n.t('speak')
                    break;
                case 'listening':
                    result = this.$i18n.t('listen')
                    break;
                case 'writing':
                    result = this.$i18n.t('write')
                    break;
            }
            return result;
        }

    }
}
</script>

<style scoped>
.rate {
    width: 14px;
    height: 23px;
    display: inline-block;
    background: rgba(170, 171, 183, 0.2);
}

.rate.red.active {
    background: #EE3E54;
}

.rate.green.active {
    background: #3DBC77;
}

.rate.yellow.active {
    background: #FFD699;
}

.rate.orange.active {
    background: #F6851F;
}

.rate-label {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 23px;
    color: #1B1B1B;
    width: 92px;
    margin-left: 10px;
    vertical-align: super;
    display: inline-block;
    text-align: left;
}
</style>